import React from 'react';
import styled from 'styled-components/macro';
import { Paragraph } from './Text';
import { ReactComponent as SquiggleSvg } from '../svg/squiggle-highlight.svg';

const AssetLinkCategory = styled.div`
  display: inline-block;
  font-size: 0.8em;
  font-weight: 600;
  text-transform: uppercase;
  margin-top: 2em;
  position: relative;
  max-width: calc(50%);
  color: ${props => props.theme.colors.white};
  overflow: hidden;
`;

const CategoryContent = styled(Paragraph)`
  margin: 0.6em 2.5rem 0.4em 2rem;
`;

const HighlightWrapper = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  color: ${props => props.theme.colors.boogaloo};
  z-index: -1;
  width: 100%;
  height: 100%;
`;

const Highlight = styled(SquiggleSvg)`
  width: 100%;
  height: 100%;
  transform: rotate(180deg) scaleX(-1);

  path {
    fill: ${props =>
      props.active
        ? props.theme.colors.briangerine
        : props.theme.colors.smokem};
  }
`;

const CategoryLabelBlock = props => {
  const { category, url } = props;

  return (
    !!props.category && (
      <div>
        <AssetLinkCategory>
          <CategoryContent>{category}</CategoryContent>
          <HighlightWrapper>
            <Highlight active={url} />
          </HighlightWrapper>
        </AssetLinkCategory>
      </div>
    )
  );
};

CategoryLabelBlock.defaultProps = {
  category: null,
  url: null,
};

export default CategoryLabelBlock;
